import { z } from 'zod';
import type { IscEnrollmentStatusDto } from './iscEnrollmentStatus.dto';

/**
 * Request body for on-demand ISC needs-survey sync + enrollment projection update.
 */
export const SyncIscNeedsSurveyRequestSchema = z
  .object({
    memberIds: z.array(z.string().uuid()).min(1),
  })
  .strict();

/** Inferred sync-request type. */
export type SyncIscNeedsSurveyRequestDto = z.infer<
  typeof SyncIscNeedsSurveyRequestSchema
>;

/**
 * Response after syncing needs-survey completion onto enrollment projection.
 * Partial failures are reported in-band via `failedMemberIds` (HTTP 200).
 * `enrollmentStatuses` is aligned with `memberIds`; entries are `null` when the
 * member is missing or soft-deleted (status cannot be loaded).
 */
export type SyncIscNeedsSurveyResponseDto = {
  memberIds: string[];
  syncedMemberIds: string[];
  failedMemberIds: string[];
  enrollmentStatuses: Array<IscEnrollmentStatusDto | null>;
};
